import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import './Subscribe.css';

const SubscribeCancel: React.FC = () => {
  useEffect(() => {
    document.title = 'Checkout Cancelled — FitMind AI';
  }, []);

  return (
    <div className="subscribe-page">
      <header className="subscribe-header">
        <Link to="/" className="subscribe-logo">
          <img src="/logo.png" alt="FitMind AI" />
        </Link>
      </header>

      <main className="subscribe-main">
        <div className="subscribe-card">
          <div className="subscribe-icon subscribe-icon--cancel">
            <span>×</span>
          </div>
          <h1>Checkout cancelled</h1>
          <p>
            No payment was taken. You can upgrade to Pro anytime from within the
            FitMind AI app.
          </p>
          <a className="subscribe-btn subscribe-btn--primary" href="fitmindai://paywall">
            Return to app
          </a>
          <Link to="/" className="subscribe-btn subscribe-btn--outline">
            Back to website
          </Link>
        </div>
      </main>

      <footer className="subscribe-footer">
        <div className="container">
          <Link to="/">FitMind AI</Link>
          <span>·</span>
          <Link to="/privacy">Privacy Policy</Link>
          <span>·</span>
          <Link to="/terms">Terms of Service</Link>
        </div>
      </footer>
    </div>
  );
};

export default SubscribeCancel;
